export default class SnippetIsInvalidError extends Error {}
